import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAppSelector } from '@app/core/hooks';

import { APP_PATH } from 'src/config/app-paths';
import { isAuthenticated } from 'src/core/authentication/authentication.slice';

export const DefaultController = (): React.JSX.Element => {
  const isUserAuthenticated = useAppSelector(isAuthenticated);

  return (
    <Navigate
      to={isUserAuthenticated ? APP_PATH.DASHBOARD : APP_PATH.LOGIN}
      replace
    />
  );
};
